/*eslint eqeqeq: "off"*/
/**
 * VENDOR MODULES
 */
import React from 'react';
// import { useTranslation } from "react-i18next"; // Removed - not currently used

import { getMarketTypeByGroupId } from 'shared/utils/markets';
import OutcomeImages from 'shared/components/outcomes/OutcomeImages';
import GridOdd from 'shared/components/outcomes/grids/GridOdd';

/**
 * Renders the straight forecast market outcome table
 *
 * - market group:  504
 * - market type: 1004, 2004
 *
 * @class      StraightForecast (name)
 * @param      {Object}   props   The properties
 * @return     {DOM}
 */
function StraightForecast(props) {
  // const { t } = useTranslation(); // Removed - not currently used
  const { event_id, runners: runnersProp = [], n_runners, sport_id, outcomes: outcomesProp } = props;
  if (!event_id) {
    return (<></>);
  }

  // Do not invent runners; require backend-provided runners.
  const runners = runnersProp || [];
  if (!runners.length) {
    return (
      <div className="p-4 text-sm text-muted-foreground">No runners available.</div>
    );
  }

  const outcomesList = Array.isArray(outcomesProp)
    ? outcomesProp
    : outcomesProp && typeof outcomesProp === 'object'
      ? Object.values(outcomesProp)
      : [];

  const mkg_id = 504;
  const mk_id = (getMarketTypeByGroupId(mkg_id, props) ?? {}).market_type_id;
  const common_props = {
    n_runners: n_runners,
    sport_id: sport_id,
    market_type_group_id: mkg_id,
    market_type_id: mk_id,
    event_id: event_id,
    event: props,
  };

  return (
    <div className="straight-forecast-wrapper w-full">
      <div className="w-full">
        {/* Header Row as true grid */}
        <div
          className="grid items-center text-xs md:text-sm border-b border-gray-200 py-1 gap-1"
          style={{ gridTemplateColumns: `minmax(2.25rem, 1fr) repeat(${n_runners}, 1fr)` }}
        >
          <div />
          {runners.map((_, index) => (
            <div key={index} className="flex items-center justify-center w-full">
              <div className="h-8 w-full flex items-center justify-center">
                <OutcomeImages {...{outcome: index + 1, n_runners: n_runners, sport_id: sport_id, br: 0}}/>
              </div>
            </div>
          ))}
        </div>

        {/* Data Rows as true grid */}
        {runners.map((_, rowIndex) => {
          const isEvenRow = rowIndex % 2 === 1;
          return (
          <div
            key={rowIndex}
            className={`grid items-center border-b border-gray-100 py-1 gap-1 ${isEvenRow ? 'bg-gray-50' : ''}`}
            style={{ gridTemplateColumns: `minmax(2.25rem, 1fr) repeat(${n_runners}, 1fr)` }}
          >
            {/* First column - Runner icon */}
            <div className="flex items-center justify-center">
              <OutcomeImages {...{outcome: rowIndex + 1, n_runners: n_runners, sport_id: sport_id, br: 0}}/>
            </div>

            {/* Odds columns */}
            {runners.map((_, colIndex) => {
              if (rowIndex === colIndex) {
                // Empty cell for same runner
                return (
                  <div key={colIndex} className="h-8" />
                );
              }

              const outcome = `${rowIndex + 1}-${colIndex + 1}`;
              const outcomeObj =
                outcomesList.find((o) => String(o?.market_type_id) === String(mk_id) && String(o?.outcome) === outcome) || null;
              const odd = outcomeObj?.odd ?? null;

              return (
                <div key={colIndex} className="">
                  <GridOdd
                    {...common_props}
                    {...(outcomeObj || {})}
                    outcome={outcome}
                    odd={odd}
                    class_names={["w-full h-8 text-xs"]}
                  />
                </div>
              );
            })}
          </div>
          );
        })}
      </div>
    </div>
  );
}

export default StraightForecast;

